<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >{{ selectedRepresentativeData ? 'Edit' : 'Add' }} Representative</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-row">
                    <div class="col-md-6">
                        <label for="accountno required">First Name *</label>
                        <div class="input-group mb-3">
                            <input  type="text" class="form-control" id="firstName" v-model="firstName">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="accountno required">Last Name</label>
                        <div class="input-group mb-3">
                            <input  type="text" class="form-control" id="lastName" v-model="lastName">
                        </div>
                    </div>

                </div>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button v-if="!selectedRepresentativeData"  :disabled="!firstName" type="button" class="btn btn-primary" @click="addRep()">ADD</button>
                    <button v-if="selectedRepresentativeData" :disabled="!firstName" type="button" class="btn btn-primary" @click="updateRep()">UPDATE</button>
                </div>
            </form>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

            </div>
          </div>
        </div>
      </div>
</template>
<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'moneyLineEditmodal',
        components :{
        },
        props: ['selectedRepresentativeData'],
        data() {
            return {
                loading : false,
                errors: [],
                accountData : null,
                firstName : "",
                lastName : ""
            };
        },
        methods: { 
            updateRep(){
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.loading = true;
                let dataToSend = {
                    "id" : this.selectedRepresentativeData.id,
                    "firstName": this.firstName,
                    "lastName": this.lastName
                }
                this.$http
                .put(config.baseUrlAutoBidder + "/money-line/representative", dataToSend, auth)
                .then(() => {
                    this.loading = false;  
                    this.$alert("Successfully Updated","","success");
                    this.$emit('close');               
                })
                .catch(() => {
                    this.loading = false;              
                });
            },
            addRep(){
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.loading = true;
                let dataToSend = {
                    "firstName": this.firstName,
                    "lastName": this.lastName
                }
                this.$http
                .post(config.baseUrlAutoBidder + "/money-line/representative", dataToSend, auth)
                .then(() => {
                    this.loading = false;  
                    this.$alert("Successfully Added","","success");
                    this.$emit('close');               
                })
                .catch(() => {
                    this.loading = false;              
                });
            }
        },
        created(){
            if(this.selectedRepresentativeData){
                this.firstName = this.selectedRepresentativeData.firstName;
                this.lastName = this.selectedRepresentativeData.lastName;
            }
        }
    };
    </script>
